export const ADVANCE_PAYMENT_TYPE = {
  INSTALLMENT_ADVANCE: 'INSTALLMENT_ADVANCE',
  FOR_FUTURE_SALARY: 'FOR_FUTURE_SALARY',
};
